export class AddConfirmVehicleRequest {
    public vin: string;
    public teaserPackageSku: string;
}